module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('navbar-overlay'), _vm._v(" "), _c('div', {
    class: {
      'columns': _vm.isAuthenticated && _vm.$route.name !== 'landing'
    },
    staticStyle: {
      "background-color": "#EAEBE0"
    }
  }, [(_vm.isAuthenticated && _vm.$route.name !== 'landing') ? _c('div', {
    staticClass: "side-bar-wrapper",
    class: {
      'column is-3': _vm.isAuthenticated && _vm.$route.name !== 'landing'
    },
    staticStyle: {
      "background-color": "#29353C"
    }
  }, [_c('side-bar', {
    staticClass: "side-bar"
  })], 1) : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "page-wrapper",
    class: {
      'column is-9': _vm.isAuthenticated && _vm.$route.name !== 'landing'
    }
  })], 1), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46fbf653","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 739
// module chunks = 1